/*
      DataTableV2 e' in fase di sviluppo

      bisogna completare le operazioni di edit / delete
      rimuovendo le dipendenze dal tracker context (selectedContext)
      in modo da poter usare la datatable per qualunque entita'

*/
import DataTableV2ItemEdit from '@/agilis/components/DataTableV2/DataTableV2ItemEdit/DataTableV2ItemEdit.vue'
import DataTableV2ItemView from '@/agilis/components/DataTableV2/DataTableV2ItemView/DataTableV2ItemView.vue'
import DataTableV2Title from '@/agilis/components/DataTableV2/DataTableV2Title/DataTableV2Title.vue'
import authorizationMixin from '@/agilis/components/DataTableV2/common/authorizationMixin'
import filterMixin from '@/agilis/components/DataTableV2/common/filterMixin'
import dumpUserActionMixin from '@/agilis/components/DataTableV2/common/dumpUserActionMixin'
import configurationMixin from '@/agilis/components/DataTableV2/common/configurationMixin'
import tableActionsMixin from '@/agilis/components/DataTableV2/common/tableActionsMixin'
import searchMixin from '@/agilis/components/DataTableV2/common/searchMixin'
import renderMixin from '@/agilis/components/DataTableV2/common/renderMixin'
import toursMixin from '@/agilis/components/Tour/mixins/toursMixin'
import deleteMixin from '@/agilis/components/DataTableV2/common/deleteMixin'
import dashboardMixin from '@/agilis/components/DataTableV2/common/dashboardMixin'
import viewMixin from '@/agilis/components/DataTableV2/common/viewMixin'
import linkToMixin from '@/agilis/components/DataTableV2/common/linkToMixin'
import exportMixin from '@/agilis/components/DataTableV2/common/exportMixin'

export default {
  name: 'DataTableV2',
  mixins: [
    authorizationMixin,
    dumpUserActionMixin,
    filterMixin,
    configurationMixin,
    deleteMixin,
    tableActionsMixin,
    linkToMixin,
    searchMixin,
    renderMixin,
    toursMixin,
    dashboardMixin,
    viewMixin,
    exportMixin
  ],

  props: {
    api: String,
    title: String,
    description: String,
    viewComponentId: String,
    editComponentId: String,
    configuration: Object,
    accessType: String
  },

  components: {
    DataTableV2ItemEdit,
    DataTableV2ItemView,
    DataTableV2Title
  },

  methods: {
    // override ineherited of add new methods
  }
}
